module.exports = __webpack_public_path__ + "static/simple-bar-5f380faf394a4c585bb7c3e511bda9ac.png";